import React from "react";
import { Menu } from "lucide-react";

const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  return (
    <header className="header shadow-sm sticky top-0 z-20 w-full bg-app md:hidden">
      <div className="px-0 md:px-0 py-2 flex justify-between items-center h-14">
        {/* Mobile menu toggle */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="md:hidden text-theme hover:opacity-90 ml-3"
          aria-label="Toggle sidebar"
        >
          <Menu className="h-5 w-5" style={{ color: "var(--color-text)" }} />
        </button>

        <h1 className="text-base font-bold text-theme md:hidden ml-3">
          GlobalTrade<span className="link-theme">Pro</span>
        </h1>

        <div className="flex-1" />
      </div>
    </header>
  );
};

export default Header;
